import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {environment} from '../../environments/environment';
import {AuthService} from './auth.service';
import {HttpError} from './api.service';
import {ActivatedRoute} from '@angular/router';

const HEX_PATTERN = /^[0-9a-fA-F]+$/;

@Injectable()
export class AnalyticsService {

  private gaLoaded = false;

  constructor(private route: ActivatedRoute,
              private Title: Title,
              private Auth: AuthService) {
    if (window.ga && environment.googleAnalyticsKey) {
      window.ga('create', environment.googleAnalyticsKey, environment.name === 'local' ? 'none' : 'auto');
      this.gaLoaded = true;
    }
  }

  identify(data: User): void {
    const id = AnalyticsService.deobfuscateId(data.id);
    if (this.gaLoaded) window.ga('set', 'userId', data.username);
  }

  trackEvent(eventName: string, properties?: any /* TODO type? */): void {
    properties = {...(properties || {}), ...this.route.snapshot.params};
    AnalyticsService.deobfuscateProperties(properties);
    properties.environment = environment.name;
    properties.page = document.location.href;
    properties.title = this.Title.getTitle();
    properties.authenticated = this.Auth.isFullyAuthenticated();
    properties.authType = this.Auth.getAuthType();
    this.logEvent(eventName, properties);

    if (this.gaLoaded) {
      window.ga('send', 'event', properties.category || 'Event', eventName, properties.label, properties.value);
    }
  }

  trackPageView(properties?: any): void {
    properties = {...(properties || {})};
    AnalyticsService.deobfuscateProperties(properties);
    properties.environment = environment.name;
    properties.page = document.location.href;
    properties.title = this.Title.getTitle();
    properties.authenticated = this.Auth.isFullyAuthenticated();
    properties.authType = this.Auth.getAuthType();
    this.logEvent('Page View', properties);
    if (this.gaLoaded) {
      window.ga('send', 'pageview', properties.page, {title: properties.title});
    }
  }

  trackAjaxError(err: HttpError): void {
    // if (!err || !err.status || err.status === 404) {
    //   return;
    // }
    // const properties = {
    //   category: 'Error',
    //   label: 'AJAX error',
    //   data: err.data,
    //   url: err.config.url
    // };
    // this.logEvent('AJAX error ' + err.status, properties);
    // this.trackEvent('AJAX error ' + err.status, properties);
  }

  private waitFor<T>(name: string, property: string, callback: (api: T) => void): void {
    let count = 0;
    const timeout = setInterval(() => {
      const ctx: any = window;
      if (ctx[name] && ctx[name][property]) {
        clearTimeout(timeout);
        callback(ctx[name]);
      } else {
        if (++count === 10) {
          console.warn(`Timed out while waiting for ${name}.${property}`);
          clearTimeout(timeout);
        }
      }
    }, 500);
  }

  private logEvent(name: string, properties?: any): void {
    if (environment.name !== 'prod' && environment.name !== 'stag' && console.groupCollapsed) {
      console.groupCollapsed(`Analytics: ${name}`);
      if (properties) {
        console.log('Event properties:');
        console.dir(properties);
      } else {
        console.log('No event properties.');
      }
      console.groupEnd();
    }
  }

  static deobfuscateId(id: string): number {
    for (var s = id.substr(32), i = s.length - 1, o = ''; i >= 0; o += s[i--]) {
    }
    return parseInt(o, 16);
  }

  private static deobfuscateProperties(properties: any) {
    ['positionId', 'profileId', 'personId', 'id', 'view'].forEach(name => {
      const prop = properties[name];
      if (prop && prop.length > 32 && HEX_PATTERN.test(prop)) {
        properties[name] = AnalyticsService.deobfuscateId(prop);
      }
    });
  }
}
